/**
 * Header menu drawer runtime (snippets/header-drawer.liquid).
 */
(function () {
    // ───── Always refresh handlers on script eval ─────
    // We don't use a hard guard (like __evelinaMenuBound) because after soft
    // navigations (Section Rendering / back-forward cache) the old closure may
    // still be bound but pointing at stale DOM. Instead we flag the elements
    // themselves so we never double-bind.

    function getWrap() {
      // Prefer the most recently rendered wrap (last in DOM order)
      var wraps = document.querySelectorAll('.evelina-menu-wrap');
      return wraps.length ? wraps[wraps.length - 1] : null;
    }

    function ensureBackdrop() {
      // Guarantee exactly ONE backdrop and make sure it lives in <body>
      // (NOT inside #header-component, which has `contain: layout` and would
      // constrain a fixed-position backdrop to the header's rect).
      var all = document.querySelectorAll('.evelina-backdrop');
      var kept = null;
      for (var i = 0; i < all.length; i++) {
        var bd = all[i];
        if (!kept) {
          kept = bd;
        } else {
          bd.remove();
        }
      }
      if (!kept) {
        kept = document.createElement('div');
        kept.className = 'evelina-backdrop';
        kept.setAttribute('aria-hidden', 'true');
        kept.setAttribute('data-skip-node-update', 'true');
        kept.setAttribute('data-open', 'false');
      }
      if (kept.parentElement !== document.body) {
        document.body.appendChild(kept);
      }
      return kept;
    }

    function ensureMenuPanel() {
      // Portal the menu panel to <body> for the same reason as the backdrop:
      // `.header` has `contain: layout` which would otherwise constrain
      // `position: fixed` to the header rect — meaning when the user scrolls
      // down, the menu appears at the TOP of the document instead of the
      // viewport. Moving it to <body> makes `position: fixed` viewport-relative.
      var all = document.querySelectorAll('.evelina-menu');
      var kept = null;
      for (var i = 0; i < all.length; i++) {
        var panel = all[i];
        if (!kept) {
          kept = panel;
        } else {
          panel.remove();
        }
      }
      if (kept && kept.parentElement !== document.body) {
        kept.setAttribute('data-skip-node-update', 'true');
        document.body.appendChild(kept);
      }
      return kept;
    }

    function lockScroll() {
      // Scroll-lock without breaking `position: sticky` on the header.
      // Using `overflow: hidden` on <html> would kill the sticky ancestor
      // context and the header would snap back to its natural (top) position.
      // Instead we pin <body> with position:fixed and restore on unlock.
      if (document.documentElement.classList.contains('evelina-menu-open')) return;
      var y = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.evelinaLockY = String(y);
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + y + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlockScroll() {
      if (!document.documentElement.classList.contains('evelina-menu-open')) return;
      var y = parseInt(document.body.dataset.evelinaLockY || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.evelinaLockY;
      // Temporarily force instant scroll so the restore doesn't animate
      // from top→y when a global `scroll-behavior: smooth` is active.
      var prevHtmlBehavior = document.documentElement.style.scrollBehavior;
      var prevBodyBehavior = document.body.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      // Restore on next frame so the jump is definitely committed first.
      requestAnimationFrame(function () {
        document.documentElement.style.scrollBehavior = prevHtmlBehavior;
        document.body.style.scrollBehavior = prevBodyBehavior;
      });
    }

    function setOpen(state) {
      var wrap = getWrap();
      if (!wrap) return;
      // Always (re)ensure backdrop + menu panel before toggling state.
      var backdrop = ensureBackdrop();
      var panel = ensureMenuPanel();
      if (state) lockScroll(); else unlockScroll();
      wrap.setAttribute('data-open', state ? 'true' : 'false');
      backdrop.setAttribute('data-open', state ? 'true' : 'false');
      var burger = wrap.querySelector('.evelina-burger');
      if (burger) burger.setAttribute('aria-expanded', state ? 'true' : 'false');
      if (panel) {
        panel.setAttribute('data-open', state ? 'true' : 'false');
        panel.setAttribute('aria-hidden', state ? 'false' : 'true');
      }
      document.documentElement.classList.toggle('evelina-menu-open', state);
    }
    function toggle() {
      var wrap = getWrap();
      setOpen(!(wrap && wrap.getAttribute('data-open') === 'true'));
    }
    function close() { setOpen(false); }

    // Event delegation on <html> — bind once per window, survives section swaps
    if (!window.__evelinaMenuClickBound) {
      window.__evelinaMenuClickBound = true;

      document.documentElement.addEventListener('click', function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        if (t.closest('.evelina-burger')) {
          e.preventDefault();
          toggle();
          return;
        }
        if (t.closest('.evelina-backdrop')) {
          close();
          return;
        }
        // Localization: toggle the shared panel area to show the requested list
        var locToggle = t.closest('[data-evelina-loc-toggle]');
        if (locToggle) {
          e.preventDefault();
          var box = locToggle.closest('.evelina-menu__localization');
          if (box) {
            var target = locToggle.getAttribute('data-target') || '';
            var currentlyOpen = box.getAttribute('data-active-panel') || '';
            var nextPanel = currentlyOpen === target ? '' : target;
            box.setAttribute('data-active-panel', nextPanel);
            // Sync aria-expanded on every toggle button in this box
            var toggles = box.querySelectorAll('[data-evelina-loc-toggle]');
            for (var i = 0; i < toggles.length; i++) {
              var btn = toggles[i];
              var isActive = btn.getAttribute('data-target') === nextPanel;
              btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            }
          }
          return;
        }
        // Localization submit — preserve query string on return_to.
        // The native submit button carries its own name (country_code or
        // language_code), so we just need to update return_to; the hidden
        // inputs keep the "other" dimension stable.
        var locItem = t.closest('.evelina-loc__item');
        if (locItem) {
          var form = locItem.closest('form');
          if (form) {
            var returnTo = form.querySelector('input[name="return_to"]');
            if (returnTo) {
              returnTo.value = window.location.pathname + window.location.search;
            }
          }
          return; // let the native submit happen
        }
        var link = t.closest('.evelina-menu a');
        if (link) {
          setTimeout(close, 50);
        }
      }, true);

      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') close();
      });

      // Reset any stuck open state when page becomes visible / nav restores
      window.addEventListener('pageshow', function () {
        unlockScroll();
        document.documentElement.classList.remove('evelina-menu-open');
        var w = getWrap();
        if (w) w.setAttribute('data-open', 'false');
        var bd = ensureBackdrop();
        bd.setAttribute('data-open', 'false');
        var p = ensureMenuPanel();
        if (p) p.setAttribute('data-open', 'false');
      });
      window.addEventListener('popstate', function () {
        unlockScroll();
        document.documentElement.classList.remove('evelina-menu-open');
      });
    }

    // Dedupe any stray wraps (keep last — matches getWrap)
    function dedupeWraps() {
      var wraps = document.querySelectorAll('.evelina-menu-wrap');
      for (var i = 0; i < wraps.length - 1; i++) wraps[i].remove();
    }

    // Run now + on DOM ready + observe for section swaps
    function sync() {
      dedupeWraps();
      ensureBackdrop();
      ensureMenuPanel();
    }
    sync();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync, { once: true });
    }
    // One observer per window
    if (!window.__evelinaMenuObserver) {
      window.__evelinaMenuObserver = new MutationObserver(function (muts) {
        // Only react when header/body children actually changed (avoid loops)
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].type === 'childList' &&
              (muts[i].addedNodes.length || muts[i].removedNodes.length)) {
            sync();
            return;
          }
        }
      });
      window.__evelinaMenuObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  })();
